import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(({ typography }) => ({
  iconButton: {
    fontFamily: typography.fontFamily,
    fontSize: '12px',
    fill: 'gray',
    marginLeft: '0px',
    marginRight: '6px',
    paddingLeft: 0,
    paddingRight: 0,

    '&:hover': {
      color: '#4001C5',
      backgroundColor: 'transparent',
      borderRadius: '0px',
      boxShadow: '0 3px #4001C5',

      '& svg': {
        fill: '#4001C5',
      },
    },
    '&.active': {
      color: '#4001C5',
      backgroundColor: 'transparent',
      borderRadius: '0px',
      boxShadow: '0 3px #4001C5',

      '& svg': {
        fill: '#4001C5',
      },
    },
  },
  badgeButtonText: {
    paddingLeft: '16px',
    color: 'rgba(0, 0, 0, 0.8)',
    '&:hover': {
      color: '#4001C5',
      fill: '#4001C5',
    },
    '&.active': {
      color: '#4001C5',
    },
  },
}));
